import { render, staticRenderFns } from "./HolderEditButton.vue?vue&type=template&id=78400fe0&scoped=true&"
import script from "./HolderEditButton.vue?vue&type=script&lang=ts&"
export * from "./HolderEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./HolderEditButton.vue?vue&type=style&index=0&id=78400fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78400fe0",
  null
  
)

export default component.exports